
import { defineComponent, ref } from 'vue'
import { useStore } from 'vuex'
import { axiosSetting } from '@/utils/axiosSetting'
import Button from '@/components/elements/Button.vue'
import CbtTermCard from '@/components/block/CbtTermCard.vue'
import CbtAllResultChart from '@/components/block/CbtAllResultChart.vue'
import CbtLatestScore from '@/components/block/CbtLatestScore.vue'

const parseTestScore = (graphDataString: string) => {
  if (graphDataString.length === 0) return []
  const array = graphDataString.split(',').map(Number)
  // 第五項は1.5倍
  array[4] = array[4] * 1.5
  return array
}
const parseTestDate = (graphDateString: string) => {
  if (graphDateString.length === 0) return []
  const dateArray = graphDateString.split(',').map((date) => date.split(' ')[0])
  return dateArray
}
const getTestDates = (dateStringArray: string[]) => {
  const graphDates = dateStringArray.map((dateString) =>
    parseTestDate(dateString)
  )
  return graphDates
}

export default defineComponent({
  name: 'CbtAllResult',
  components: {
    Button,
    CbtTermCard,
    CbtAllResultChart,
    CbtLatestScore
  },
  setup() {
    const store = useStore()
    const result = ref({})
    const ajax = axiosSetting('app', 'action')
    const params = {
      users_id: store.state.userInfo.zip,
      year: '2022'
    }

    const getData = async () => {
      const data = await ajax
        .post('/api/v1/cbt_results', params)
        .then((res: any) => {
          return res.data
        })
      data.firstScore = parseTestScore(data.graph)
      data.latestScore = parseTestScore(data.graph_new)
      data.numberOfTests = data.past_performance.length
      data.testDates =
        data.numberOfTests > 1
          ? getTestDates([data.graph_date, data.graph_new_date])
          : getTestDates([data.graph_date])
      result.value = data
    }
    getData()

    const terms = [
      {
        title: '基本事項 / 医学一般(30問)'
      },
      {
        title: '人体各器官の正常構造と機能、病態、診断、治療(30問)'
      },
      {
        title: '全身に及ぶ生理的変化、病態、診断、治療(30問)'
      },
      {
        title: '診療の基本 / 社会と医学・医療(30問)'
      },
      {
        title: '4連問特集(20問)'
      }
    ]

    return {
      result,
      terms
    }
  }
})
